import axios from 'axios';
import { configs } from '../app/app-configs';
import { BiometricDevice, BiometricDeviceRequest } from './model/biometric.model';

export const getBiometricDevices = async (): Promise<BiometricDevice[]> => {
    return await axios.get(`${configs.BASE_URL}/biometric-devices`).then((res) => {
        return res.data;
    });
};

export const createBiometricDevice = async (
    request: BiometricDeviceRequest
): Promise<BiometricDevice> => {
    return await axios
        .post(`${configs.BASE_URL}/biometric-devices`, request)
        .then((res) => {
            return res.data as BiometricDevice;
        });
};

export const updateBiometricDevice = async (
    request: BiometricDeviceRequest
): Promise<BiometricDevice> => {
    return await axios
        .put(`${configs.BASE_URL}/biometric-devices/${request.id}`, request)
        .then((res) => {
            return res.data as BiometricDevice;
        });
};

export const deleteBiometricDevice = async (id: number): Promise<number> => {
    return await axios
        .delete(`${configs.BASE_URL}/biometric-devices/${id}`)
        .then((res) => {
            return res.data;
        });
};
